module.exports = __webpack_public_path__ + "static/CIS-logo-4216869d826324a78401da302312100d.svg";